import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { setAlert } from "./alert.slice";
import { BASE_URL } from "../../utils/baseURL";
import Cookies from 'js-cookie';

const initialState = {
    aggregate: [],
    piechart: [],
    linechart: [],
    stackchart: [],
    marketBarChartData: [],
    MarLiaData: [],
    dealerBar: [],
    eleBar: [],
    fabBar: [],
    techBar: [],
    user: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getAggregate = createAsyncThunk(
    'aggregatedata/get',
    async ({ selectedCommonfilter, selectedDate }, { dispatch, rejectWithValue }) => {
        try {

            console.log("selectedCommonfilter", selectedCommonfilter);

            let params = {};

            if (selectedCommonfilter === "month") {
                params = {
                    selectedfilter: "month",
                    m: selectedDate.$M,
                    y: selectedDate.$y,
                };
            } else if (selectedCommonfilter === "year") {
                params = {
                    selectedfilter: "year",
                    y: selectedDate.$y,
                };
            } else if (selectedCommonfilter === "financialYear") {
                params = {
                    selectedfilter: "financialYear",
                    y: selectedDate.$y,
                };
            } else {
                params = {
                    selectedfilter: "total",
                };
            }

            const response = await axiosInstance.get(BASE_URL + '/aggregatedata', {
                params,
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });



            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getpiechart = createAsyncThunk(
    'piechart/get',
    async ({ selectedCommonfilter, selectedDate }, { dispatch, rejectWithValue }) => {
        try {
            let params = {};

            if (selectedCommonfilter === "month") {
                params = {
                    selectedfilter: "month",
                    m: selectedDate.$M,
                    y: selectedDate.$y,
                };
            } else if (selectedCommonfilter === "year") {
                params = {
                    selectedfilter: "year",
                    y: selectedDate.$y,
                };
            } else if (selectedCommonfilter === "financialYear") {
                params = {
                    selectedfilter: "financialYear",
                    y: selectedDate.$y,
                };
            } else {
                params = {
                    selectedfilter: "total",
                };
            }

            const response = await axiosInstance.get(BASE_URL + '/piechart', {
                params,
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getlinechart = createAsyncThunk(
    'linechart/get',
    async ({ selectedfilter }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/linechart', {
                params: {
                    selectedfilter: selectedfilter
                },
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getStackchartData = createAsyncThunk(
    'chartData/get',
    async ({ selectedfilter }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/chartData', {
                params: {
                    selectedfilter: selectedfilter
                },
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getMarketBarChartData = createAsyncThunk(
    'marketBarChartData/get',
    async ({ selectedCommonfilter, selectedDate }, { dispatch, rejectWithValue }) => {
        try {
            let params = {};

            if (selectedCommonfilter === "month") {
                params = {
                    selectedfilter: "month",
                    m: selectedDate.$M,
                    y: selectedDate.$y,
                };
            } else if (selectedCommonfilter === "year") {
                params = {
                    selectedfilter: "year",
                    y: selectedDate.$y,
                };
            } else if (selectedCommonfilter === "financialYear") {
                params = {
                    selectedfilter: "financialYear",
                    y: selectedDate.$y,
                };
            } else {
                params = {
                    selectedfilter: "total",
                };
            }

            const response = await axiosInstance.get(BASE_URL + '/getMarketBarChartData', {
                params,
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getMarLiaBarChartData = createAsyncThunk(
    'marLiaChartData/get',
    async ({ selectedCommonfilter, selectedDate }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/marketingAndLiaosningChart', {
                params: {
                    selectedfilter: selectedCommonfilter,
                    m: selectedDate.$M,
                    y: selectedDate.$y
                },
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getdealerBarChart = createAsyncThunk(
    'dealerBarChart/get',
    async ({ selectedCommonfilter, selectedDate }, { dispatch, rejectWithValue }) => {
        try {
            let params = {};

            if (selectedCommonfilter === "month") {
                params = {
                    selectedfilter: "month",
                    m: selectedDate.$M,
                    y: selectedDate.$y,
                };
            } else if (selectedCommonfilter === "year") {
                params = {
                    selectedfilter: "year",
                    y: selectedDate.$y,
                };
            } else if (selectedCommonfilter === "financialYear") {
                params = {
                    selectedfilter: "financialYear",
                    y: selectedDate.$y,
                };
            } else {
                params = {
                    selectedfilter: "total",
                };
            }
            const response = await axiosInstance.get(BASE_URL + '/dealerDashboard', {
                params,
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const geteleBarChart = createAsyncThunk(
    'eleBarChart/get',
    async ({ selectedfilter }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/electricionDashboard', {
                params: {
                    selectedfilter: selectedfilter,
                },
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getfabBarChart = createAsyncThunk(
    'fabBarChart/get',
    async ({ selectedfilter }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/fabricatorDashboard', {
                params: {
                    selectedfilter: selectedfilter,
                },
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const gettechBarChart = createAsyncThunk(
    'techBarChart/get',
    async ({ selectedfilter }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/technicianDashboard', {
                params: {
                    selectedfilter: selectedfilter,
                },
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getuserDashboard = createAsyncThunk(
    'user/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getUsersinDashboard', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.user;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);;


const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // getAggregate
            .addCase(getAggregate.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Aggregate Chart...';
            })
            .addCase(getAggregate.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Aggregate Chart fetched successfully';
                state.aggregate = action.payload;
            })
            .addCase(getAggregate.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // piechart
            .addCase(getpiechart.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Pie Chart...';
            })
            .addCase(getpiechart.fulfilled, (state, action) => {
                // 
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Pie Chart fetched successfully';
                state.piechart = action.payload;
            })
            .addCase(getpiechart.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // linechart
            .addCase(getlinechart.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Line Chart...';
            })
            .addCase(getlinechart.fulfilled, (state, action) => {
                // 
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Line Chart fetched successfully';
                state.linechart = action.payload;
            })
            .addCase(getlinechart.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // getStackchartData
            .addCase(getStackchartData.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Stack Chart...';
            })
            .addCase(getStackchartData.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Stack Chart fetched successfully';
                state.stackchart = action.payload;
            })
            .addCase(getStackchartData.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // marketBarChartData
            .addCase(getMarketBarChartData.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Market Bar Chart...';
            })
            .addCase(getMarketBarChartData.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Market Bar Chart fetched successfully';
                state.marketBarChartData = action.payload;
            })
            .addCase(getMarketBarChartData.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // getMarLiaBarChartData
            .addCase(getMarLiaBarChartData.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Market & Liasoning Bar Chart...';
            })
            .addCase(getMarLiaBarChartData.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Market & Liasoning Bar Chart fetched successfully';
                state.MarLiaData = action.payload;
            })
            .addCase(getMarLiaBarChartData.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // getdealerBar
            .addCase(getdealerBarChart.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Dealer Bar Chart...';
            })
            .addCase(getdealerBarChart.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Dealer Bar Chart fetched successfully';
                state.dealerBar = action.payload;
            })
            .addCase(getdealerBarChart.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // elebar
            .addCase(geteleBarChart.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching ele Bar Chart...';
            })
            .addCase(geteleBarChart.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'ele Bar Chart fetched successfully';
                state.eleBar = action.payload;
            })
            .addCase(geteleBarChart.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // getfabBarChart
            .addCase(getfabBarChart.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching ele Bar Chart...';
            })
            .addCase(getfabBarChart.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'ele Bar Chart fetched successfully';
                state.fabBar = action.payload;
            })
            .addCase(getfabBarChart.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // gettechBarChart
            .addCase(gettechBarChart.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Technician Bar Chart...';
            })
            .addCase(gettechBarChart.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Technician Bar Chart fetched successfully';
                state.techBar = action.payload;
            })
            .addCase(gettechBarChart.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
            // getuserDashboard
            .addCase(getuserDashboard.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Technician Bar Chart...';
            })
            .addCase(getuserDashboard.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || 'Technician Bar Chart fetched successfully';
                state.user = action.payload;
            })
            .addCase(getuserDashboard.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
            })
    }
});

export default dashboardSlice.reducer;